import { t } from "i18next";
import { z } from "zod";

export const RecorderFormSchema = z.object({
  template: z.string().min(1, t("schemas.newVisit.template.min")),
  customTemplateId: z.number().nullable(),
  templateName: z.string(),
  style: z.string().min(1, t("schemas.newVisit.style.min")),
  format: z.string().min(1, t("schemas.newVisit.format.min")),
  examination: z.string().min(1, t("schemas.newVisit.examination.min")),
});

export type RecorderFormSchemaType = z.infer<typeof RecorderFormSchema>;
